import { ContentViewStyle } from '@levelapp/softfabric';
export default class RadioButtonListViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.shell = {
            display: 'flex',
            flexDirection: 'column',
        };
        this.container = {
            borderColor: '#8898aa',
            borderWidth: 2,
            borderRadius: 10,
            height: 20,
            width: 20
        };
        this.containerChecked = {
            borderColor: '#f10557',
            borderWidth: 2,
            borderRadius: 10,
            padding: 2,
            height: 20,
            width: 20
        };
        this.containerItem = {
            margin: 5,
            display: 'flex',
            flexDirection: 'row',
        };
        this.item = {
            marginLeft: 5,
        };
        this.content = {
            backgroundColor: 'white',
            width: '100%',
            height: '100%',
            borderRadius: 10
        };
        this.contentChecked = {
            backgroundColor: '#f10557',
            width: '100%',
            height: '100%',
            borderRadius: 10
        };
    }
}
